import { Alerts } from 'Feature/Slider/Cards/AlertCards';
import { ISliderSettings, SliderPanelType, SLIDERPANELTYPES } from './Models/Panels';
import { RichTextLinkBox } from './Cards/RichTextLinkBox';
import CustomerAccountLookup from 'Feature/Customers/CustomerAccountLookup';
import { useUserData } from 'Foundation/User/UserContext';
import QuoteWidget from 'Feature/Quoting/QuoteWidget';
import CustomerSearch from 'Feature/Customers/CustomerSearch';
import { FavoritesPanel } from './Cards/FavoritesPanel';
import { KeyContactsPanel } from './Cards/KeyContactsPanel';
import { IconClose } from '@lmig/lmds-react-icons';
import { SliderTile } from './Models/Tiles';
import { Mock } from 'Feature/Admin/Mock/Mock';
import LinksPanel from './Cards/LinksPanel';

interface ISliderPanelProps {
  isOpen: boolean;
  children: React.ReactNode;
  close: Function;
}
const SliderPanel = (props: ISliderPanelProps) => {
  return (
    <div className={`slider-panel ${props.isOpen ? 'open' : 'closed'}`}>
      <button className="mobile-slider-close-icon">
        <IconClose size={'16'} onClick={() => props.close()} />
      </button>
      {props.children}
    </div>
  );
};

interface IPanelsProps {
  panel: SliderTile;
  sliderSettings: ISliderSettings;
  showBadge: (title: string, showBadge: boolean) => void;
  close: Function;
  showHorizontalMenu: boolean;
}
export const Panel = (props: IPanelsProps) => {
  const { userData } = useUserData();
  function getPanel(child: SliderPanelType) {
    switch (child.type) {
      case SLIDERPANELTYPES.FAVORITESPANEL:
        return <FavoritesPanel panel={child} />;
      case SLIDERPANELTYPES.LINKSPANEL:
        return <LinksPanel panel={child} />;
      case SLIDERPANELTYPES.MOCKPANEL:
        return <Mock />;
      case SLIDERPANELTYPES.QUOTEPANEL:
        return <QuoteWidget />;
      case SLIDERPANELTYPES.RICHTEXTBOX:
        return <RichTextLinkBox panel={child} />;
      case SLIDERPANELTYPES.ALERT:
        return (
          <Alerts
            viewed={props.sliderSettings.isOpen && props.sliderSettings.activeTab === props.panel.title}
            indicateNewAlerts={(x: boolean) => props.showBadge(props.panel.title, x)}
          />
        );
      case SLIDERPANELTYPES.CUSTOMERACCOUNTLOOKUP:
        return userData?.isBL() ? (
          <CustomerAccountLookup />
        ) : (
          <CustomerSearch showHorizontalMenu={props.showHorizontalMenu} close={props.close} />
        );
      case SLIDERPANELTYPES.KEYCONTACTSPANEL:
        return (
          <KeyContactsPanel
            panel={child}
            isOpen={
              props.sliderSettings.isOpen &&
              props.sliderSettings.activeTab?.toUpperCase() === props.panel.title.toUpperCase()
            }
          />
        );
      default:
        return <></>;
    }
  }
  return (
    <>
      <SliderPanel
        key={props.panel.title}
        isOpen={
          props.sliderSettings.isOpen &&
          props.sliderSettings.activeTab?.toUpperCase() === props.panel.title.toUpperCase()
        }
        close={props.close}
      >
        {props.panel.children.map((child) => {
          return <div>{getPanel(child)}</div>;
        })}
      </SliderPanel>
    </>
  );
};
